import React, { useMemo, useRef, useState } from "react";
import { useEffect } from "react";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { useSelector } from "react-redux";
import { Checkbox, Divider, Pagination, Popup } from "semantic-ui-react";
import { getBetHistory, getBufferHistory } from "../../../api/getApi";
import NotFound from "../../../components/ProgressBlock/NotFound";
import HistoryRecord from "./HistoryRecord";
import { useTranslation } from "react-i18next";
import LoadingBetRecord from "../../../components/Loading/LoadingBetRecord";
import LoadingHistoryRecord from "../../../components/Loading/LoadingHistoryRecord";
import { FaExclamationCircle } from "react-icons/fa";

const GameHistory = ({ datePicker }) => {
  const { t } = useTranslation();
  const i18n = (key, props) => t(`betRecord.${key}`, { ...props });

  const { allGamePlatform } = useSelector((state) => state.isHandleAllGame);
  const isDarkMode = useSelector((state) => state.isTheme === "dark");

  const getSinglePlatform = useMemo(() => {
    if (allGamePlatform?.length === 0) return [];
    return allGamePlatform?.filter((item) => item.platformMode === "single");
  }, [allGamePlatform]);

  const getTransferPlatform = useMemo(() => {
    if (allGamePlatform?.length === 0) return [];
    return allGamePlatform?.filter((item) => item.platformMode === "transfer");
  }, [allGamePlatform]);

  const [platform, setPlatform] = useState("");
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    total_data: 0,
  });
  const [page, setPage] = useState(1);
  const [pageStatus, setPageStatus] = useState(false);
  const [dataLimit, setDataLimit] = useState(20); //預設一頁顯示20筆資料
  const [statusTab, setStatusTab] = useState("settled"); //預設狀態為全部

  const [isLoading, setIsLoading] = useState(false);

  const scrollContainerRef = useRef(null);

  const handleProcessResponse = (response, { isBuffer = false }) => {
    const isSearchPlatform = Boolean(response?.data?.current_page); //判斷是否有指定平台 沒有就是false
    if (isSearchPlatform) {
      const { current_page, last_page, total, data } = response?.data;
      setPageStatus(true);
      setPagination({
        current_page: current_page,
        last_page: last_page,
        total_data: total,
      });
      if (isBuffer) {
        setData(data?.filter((item) => item.status === "locked") || []);
      } else {
        setData(data || []);
      }
    } else {
      setPagination({
        current_page: 1,
        last_page: 1,
        total_data: 0,
      });
      setPageStatus(false);
      if (isBuffer) {
        setData(
          response?.data?.filter((item) => item.status === "locked") || []
        );
      } else {
        setData(response?.data || []);
      }
    }
  };

  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [page]);

  useEffect(() => {
    setIsLoading(true);

    if (statusTab === "settled") {
      getBetHistory({
        searchParams: {
          str_date: datePicker.str_date,
          end_date: datePicker.end_date,
          platform: platform,
          page: page,
          limit: dataLimit,
        },
      })
        .then((response) => {
          handleProcessResponse(response, { isBuffer: false });
        })
        .catch((err) => {})
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      getBufferHistory({
        searchParams: {
          str_date: datePicker.str_date,
          end_date: datePicker.end_date,
          platform: platform,
          page: page,
          limit: dataLimit,
        },
      })
        .then((response) => {
          handleProcessResponse(response, { isBuffer: true });
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [datePicker, platform, page, statusTab]);
  return (
    <section>
      <div className="flex items-center justify-between text-light-text my-[5px]">
        <span
          className="font-medium flex gap-[3px] items-center"
          style={{ lineHeight: "17px" }}
        >
          {i18n("Select platform")}
          <Popup
            trigger={<FaExclamationCircle className="text-gold-text text-lg" />}
            content={`${i18n("Select platform not content", {
              content: getTransferPlatform?.map((item) => {
                return `${item.platform}`;
              }),
            })}`}
            className="z-[999999]"
            style={{ zIndex: 9999999 }}
            inverted={isDarkMode}
          />
        </span>
        <select
          onChange={(e) => {
            setPlatform(e.target.value);
            setPage(1);
          }}
          className="p-[5px] !bg-base-light-white dark:!bg-base-light-dark cursor-pointer font-semibold text-light-text outline-0 !rounded-xl w-[100px] custom-select "
        >
          <option value="">{i18n("all")}</option>
          {getSinglePlatform?.map((item) => {
            return <option value={item.platform}>{item.platform}</option>;
          })}
        </select>
      </div>
      <div className="flex items-center justify-between text-light-text mt-[10px]">
        <span className="font-medium flex gap-[3px] items-center">
          {i18n("status")}
        </span>
        <div>
          <Checkbox
            onChange={(e, data) => {
              setStatusTab(data.value);
            }}
            value="settled"
            checked={statusTab === "settled"}
            radio
            label={i18n("Settled")}
          />{" "}
          <Checkbox
            onChange={(e, data) => {
              setStatusTab(data.value);
            }}
            value="process"
            checked={statusTab === "process"}
            radio
            label={i18n("Processing")}
          />
        </div>
      </div>

      <Divider />
      <section
        ref={scrollContainerRef}
        className="flex flex-col gap-[10px] overflow-y-scroll no-scrollbar h-[calc(100vh-400px)]"
      >
        {!platform && data?.length > 0 && (
          <section className="py-[3px] flex items-center justify-center w-full">
            <p className="font-medium mb-[10px] text-sm text-light-text dark:text-base-light-white tracking-tight">
              {i18n("Allremind", { dataLimit: dataLimit })}
            </p>
          </section>
        )}
        <LoadingHistoryRecord commonLoading={isLoading}>
          {data?.length === 0 && <NotFound />}
          {data?.map((item, index) => {
            const platformName = item.platform;
            const round_id = item.round_id || item.order_number;
            const isBufferOrder = statusTab === "process";
            const betAmount = item.bet || item.buffer_amount;
            return (
              <HistoryRecord
                typeIsBuffer={isBufferOrder}
                platformName={`${platformName}`}
                bet={betAmount}
                round_id={round_id}
                winLose={item.net_win}
                settle_time={item.settle_time}
                buffer_time={{
                  lock_time: item.lock_time,
                  unlock_time: item.unlock_time,
                }}
                hash={`#${
                  index + 1 + dataLimit * (page && page > 0 ? page - 1 : 0)
                }`}
              />
            );
          })}
        </LoadingHistoryRecord>
      </section>
      {data?.length === 0 || (
        <>
          <Divider />
          <section className="flex justify-center">
            <Pagination
              className="dark:!bg-base-light-dark dark-pagination"
              onPageChange={(e, data) => {
                setPage(data.activePage);
              }}
              activePage={page}
              defaultActivePage={pagination.current_page}
              totalPages={pagination.last_page}
              firstItem={null}
              lastItem={null}
              nextItem={{
                ariaLabel: "Next item",
                content: <MdKeyboardArrowRight />,
              }}
              prevItem={{
                ariaLabel: "Previous item",
                content: <MdKeyboardArrowLeft />,
              }}
            />
          </section>
        </>
      )}
    </section>
  );
};

export default GameHistory;
